import { render, staticRenderFns } from "./PharmacyHistoryRecord.vue?vue&type=template&id=586dd98b&scoped=true"
import script from "./PharmacyHistoryRecord.vue?vue&type=script&lang=js"
export * from "./PharmacyHistoryRecord.vue?vue&type=script&lang=js"
import style0 from "./PharmacyHistoryRecord.vue?vue&type=style&index=0&id=586dd98b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586dd98b",
  null
  
)

export default component.exports